import { useContext } from "react";
import { GlobalProvider } from "../../Context/GlobalState";
import { GlobalContext } from "../../Context/GlobalState";
import Select from "../../Components/Select";
import TextInput from "../../Components/TextInput";
import "./CdDosyaBilgileri.css";
import { Link } from "react-router-dom";


export default function CdDosyaBilgileri() {
  const {
    davaTarihi,
    setDavaTarihi,
    kesifTarihi,
    setKesifTarihi,
    setDosyaYili,
    dosyaYili,
    setDosyaNo,
    dosyaNo,
    setDavaci,
    davaci,
    setDavali,
    davali,
    mahkemeTurleri,
    mahkemeTuru,
    setMahkemeTuru,
    iller,
    ilceler,
    secilenSehir,
    secilenIlce,

    setSehir,
    setIlce,
    davaKonuları,
    setDavaKonusu,
    davaTuru,
    dosyaTurleri,
    setDosyaTuru,
    dosyaTuru,
    

    //avukatlar
    avukatlar,
   

    setDavaciAvukati,

    setDavaliAvukati,
    davaciAvukati,
    davaliAvukati,
    //bilirkişiler,
    kayitliBilirkisiler,
    

    birinciBilirkisi,
    setBirinciBilirkisi,
    ikinciBilirkisi,
    setIkinciBilirkisi,
    ucuncuBilirkisi,
    setUcuncuBilirkisi,
    dorduncuBilirkisi,
    setDorduncuBilirkisi,
    besinciBilirkisi,
    setBesinciBilirkisi,
    altinciBilirkisi,
    setAltinciBilirkisi,
  } = useContext(GlobalContext);

    //bb1
  const handleBirinciBilirkisi = (e) => {
    var bk1 = kayitliBilirkisiler.filter((kisi) => {
      return kisi.name === e.target.value;
    });

    setBirinciBilirkisi(bk1);
  };
  //bb2
  const handleIkinciBilirkisi = (e) => {
    var bk2 = kayitliBilirkisiler.filter((kisi) => {
      return kisi.name === e.target.value;
    });
    setIkinciBilirkisi(bk2);
  };
  //bb3
  const handleUcuncuBilirkisi = (e) => {
    var bk3 = kayitliBilirkisiler.filter((kisi) => {
      return kisi.name === e.target.value;
    });
    setUcuncuBilirkisi(bk3);
  };
  //bb4
  const handleDorduncuBilirkisi = (e) => {
    var bk4 = kayitliBilirkisiler.filter((kisi) => {
      return kisi.name === e.target.value;
    });
    setDorduncuBilirkisi(bk4);
  };
  //bb5
  const handleBesinciBilirkisi = (e) => {
    var bk5 = kayitliBilirkisiler.filter((kisi) => {
      return kisi.name === e.target.value;
    });
    setBesinciBilirkisi(bk5);
  };
  //bb6
  const handleAltinciBilirkisi = (e) => {
    var bk6 = kayitliBilirkisiler.filter((kisi) => {
      return kisi.name === e.target.value;
    });
    setAltinciBilirkisi(bk6);
  };
  return (
    <GlobalProvider>
      <div className="container">
        <div className="row">
          <h1 className="text-center my-3">Dava Dosyasına İlişkin Veriler</h1>
        </div>
        <div className="row">
          <div className="row">
            <div className="col-4">
              <label htmlFor="ilSelect">Adliye İli</label>
              <Select
                Change={setSehir}
                name="ilSelect"
                liste={iller}
                mesaj="İl Seçiniz"
                value={secilenSehir}
              />
            </div>
            <div className="col-4">
              <label htmlFor="ilceSelect">Adliye İlçesi</label>
              <Select
                Change={setIlce}
                name="ilceSelect"
                liste={ilceler}
                mesaj="İlçe Seçiniz"
                value={secilenIlce}
              />
            </div>
            <div className="col-4">
              <label htmlFor="mahkemeTuru">Mahkeme Seçiniz</label>
              <Select
                Change={setMahkemeTuru}
                name="mahkemeTuru"
                liste={mahkemeTurleri}
                mesaj="Mahkeme Seçiniz"
                value={mahkemeTuru}
              />
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-4 ">
              <label htmlFor="dosyaTuru">Dosyanın Yılı</label>
              <TextInput
                required
                name="dosyaYili"
                type="number"
                detail="Dosya Yılı"
                Change={setDosyaYili}
                value={dosyaYili}
              />
            </div>
            <div className="col-4">
              <label htmlFor="dosyaTuru">Dosyanın Numarası</label>
              <TextInput
                name="dosyaNo"
                type="number"
                detail="Dosya No"
                Change={setDosyaNo}
                value={dosyaNo}
              />
            </div>
            <div className="col-4">
              <label htmlFor="dosyaTuru">Dosyanın Türü</label>

              <Select
                Change={setDosyaTuru}
                name="dosyaTuru"
                liste={dosyaTurleri}
                mesaj="Dosya Türü Seçiniz"
                value={dosyaTuru}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <TextInput
                name="davaci"
                type="text"
                detail="Davacı/lar"
                Change={setDavaci}
                value={davaci}
              />
            </div>
            <div className="col">
              <Select
                liste={avukatlar}
                mesaj="Davacı Avukatı"
                name="davaciAvukati"
                Change={setDavaciAvukati}
                value={davaciAvukati}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <TextInput
                name="davali"
                type="text"
                detail="Davalı/lar"
                Change={setDavali}
                value={davali}
              />
            </div>
            <div className="col">
              <Select
                liste={avukatlar}
                mesaj="Davalı Avukatı"
                name="davaliAvukati"
                Change={setDavaliAvukati}
                value={davaliAvukati}
              />
            </div>
          </div>
          <div className="row">
            <div className="col">
              <Select
                liste={davaKonuları}
                mesaj="Dava Konusu"
                name="davaKonusu"
                Change={setDavaKonusu}
                value={davaTuru}
              />
            </div>
            <div className="col">
              <TextInput
                name="davaTarihi"
                type="date"
                detail="Dava Tarihi"
                Change={setDavaTarihi}
                value={davaTarihi}
              />
            </div>
            <div className="col">
              <TextInput
                name="kesifTarihi"
                type="date"
                detail="Keşif Tarihi"
                Change={setKesifTarihi}
                value={kesifTarihi}
              />
            </div>
          </div>
        </div>

        <div className="row">
          <h2 className="text-center my-3">Bilirkişi Kurulu</h2>
        </div>
        <div className="row">
          <div className="col-4">
            <div className="form-floating my-1">
              <select
                className="form-select"
                name="birinciBilirkisi"
                onChange={handleBirinciBilirkisi}
                //aria-label="Floating label select example"
              >
                <option defaultValue>
                  {birinciBilirkisi ? birinciBilirkisi[0].name : "--Seçiniz--"}
                </option>

                {kayitliBilirkisiler &&
                  kayitliBilirkisiler.map((bilirkisi) => (
                    <option key={bilirkisi.name}>{bilirkisi.name}</option>
                  ))}
              </select>
              <label htmlFor="floatingSelect">Bilirkişi</label>
            </div>
          </div>
          <div className="col-4">
            <div className="form-floating my-1">
              <select
                className="form-select"
                name="ikinciBilirkisi"
                onChange={handleIkinciBilirkisi}
                //aria-label="Floating label select example"
              >
                <option defaultValue>
                  {ikinciBilirkisi ? ikinciBilirkisi[0].name : "--Seçiniz--"}
                </option>

                {kayitliBilirkisiler &&
                  kayitliBilirkisiler.map((bilirkisi) => (
                    <option key={bilirkisi.name}>{bilirkisi.name}</option>
                  ))}
              </select>
              <label htmlFor="floatingSelect">Bilirkişi</label>
            </div>
          </div>
          <div className="col-4">
            <div className="form-floating my-1">
              <select
                className="form-select"
                name="ucuncuBilirkisi"
                onChange={handleUcuncuBilirkisi}
                //aria-label="Floating label select example"
              >
                <option defaultValue>
                  {ucuncuBilirkisi ? ucuncuBilirkisi[0].name : "--Seçiniz--"}
                </option>

                {kayitliBilirkisiler &&
                  kayitliBilirkisiler.map((bilirkisi) => (
                    <option key={bilirkisi.name}>{bilirkisi.name}</option>
                  ))}
              </select>
              <label htmlFor="floatingSelect">Bilirkişi</label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-4">
            {" "}
            <div className="form-floating my-1">
              <select
                className="form-select"
                name="dorduncuBilirkisi"
                onChange={handleDorduncuBilirkisi}
                //aria-label="Floating label select example"
              >
                <option defaultValue>
                  {dorduncuBilirkisi
                    ? dorduncuBilirkisi[0].name
                    : "--Seçiniz--"}
                </option>

                {kayitliBilirkisiler &&
                  kayitliBilirkisiler.map((bilirkisi) => (
                    <option key={bilirkisi.name}>{bilirkisi.name}</option>
                  ))}
              </select>
              <label htmlFor="floatingSelect">Bilirkişi</label>
            </div>
          </div>
          <div className="col-4">
            {" "}
            <div className="form-floating my-1">
              <select
                className="form-select"
                name="besinciBilirkisi"
                onChange={handleBesinciBilirkisi}
                //aria-label="Floating label select example"
              >
                <option defaultValue>
                  {besinciBilirkisi ? besinciBilirkisi[0].name : "--Seçiniz--"}
                </option>

                {kayitliBilirkisiler &&
                  kayitliBilirkisiler.map((bilirkisi) => (
                    <option key={bilirkisi.name}>{bilirkisi.name}</option>
                  ))}
              </select>
              <label htmlFor="floatingSelect">Bilirkişi</label>
            </div>
          </div>
          <div className="col-4">
            {" "}
            <div className="form-floating my-1">
              <select
                className="form-select"
                name="altinciBilirkisi"
                onChange={handleAltinciBilirkisi}
                //aria-label="Floating label select example"
              >
                <option defaultValue>
                  {altinciBilirkisi ? altinciBilirkisi[0].name : "--Seçiniz--"}
                </option>

                {kayitliBilirkisiler &&
                  kayitliBilirkisiler.map((bilirkisi) => (
                    <option key={bilirkisi.name}>{bilirkisi.name}</option>
                  ))}
              </select>
              <label htmlFor="floatingSelect">Bilirkişi</label>
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-3"></div>
          <div className="col-3"></div>
          <div className="col-3"></div>
          <div className="col-3">
            <Link to="/cdtasinmazlar">
              <button className="btn btn-primary btn-lg mt-5">
                Taşınmaz Bilgilerine Git{" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  fill="currentColor"
                  className="bi bi-arrow-right-circle"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M1 8a7 7 0 1 0 14 0A7 7 0 0 0 1 8m15 0A8 8 0 1 1 0 8a8 8 0 0 1 16 0M4.5 7.5a.5.5 0 0 0 0 1h5.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L10.293 7.5z"
                  />
                </svg>
              </button>
            </Link>
          </div>
        </div>
      </div>
    </GlobalProvider>
  );
}
